import { Fragment, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Login
import Login from './views/auth/Login';

// Dashboard
import Dashboard from './views/dashboard/Dashboard';

// Usuarios
import Usuarios from './views/usuarios/Usuarios';
import NuevoUsuario from './views/usuarios/NuevoUsuario';
import EditarUsuario from './views/usuarios/EditarUsuario';

// Proveedores
import Proveedores from './views/proveedores/Proveedores';
import NuevoProveedor from './views/proveedores/NuevoProveedor';
import EditarProveedor from './views/proveedores/EditarProveedor';
import ProductosProveedores from './views/proveedores/productos/Productos';

// Configuración
import Perfil from './views/configuracion/perfil/Perfil';
import Categorias from './views/configuracion/categorias/Categorias';
import Subcategorias from './views/configuracion/categorias/subcategorias/Subcategorias';
import Productos from './views/configuracion/productos/Productos';
import Areas from './views/configuracion/areas/Areas';
import Organizadores from './views/configuracion/areas/Organizadores';
import Ubicaciones from './views/configuracion/areas/Ubicaciones';
import Unidades from './views/configuracion/unidades/Unidades';
import MetodosPago from './views/configuracion/metodos/MetodosPago';
import Paquetes from './views/configuracion/paquetes/Paquetes';
import NuevoPaquete from './views/configuracion/paquetes/NuevoPaquete';
import EditarPaquete from './views/configuracion/paquetes/EditarPaquete';

//Facturas
import Facturas from './views/facturas/Facturas';
import NuevaFactura from './views/facturas/NuevaFactura';
import EditarFactura from './views/facturas/EditarFactura';

//Inventario
import Inventario from './views/inventario/Inventario';
import Movimientos from './views/inventario/movimientos/Movimientos';
import NuevoMovimiento from './views/inventario/movimientos/NuevoMovimiento';
import CargaInventario from './views/inventario/carga/CargaInventario';

//Clientes
import Clientes from './views/clientes/Clientes';
import DetalleCliente from './views/clientes/DetalleCliente';

//Ventas
import Ventas from './views/ventas/Ventas';
import NuevaVenta from './views/ventas/NuevaVenta';
import EditarVenta from './views/ventas/EditarVenta';
import DetalleVenta from './views/ventas/DetalleVenta';

//Proyectos
import Proyectos from './views/proyectos/Proyectos';
import DetalleProyecto from './views/proyectos/DetalleProyecto';
import NuevaCotizacion from './views/proyectos/cotizaciones/NuevaCotizacion';
import EditarCotizacion from './views/proyectos/cotizaciones/EditarCotizacion';
import DetalleCotizacion from './views/proyectos/cotizaciones/DetalleCotizacion';
import NuevaVersionCotizacion from './views/proyectos/cotizaciones/NuevaVersionCotizacion';
import NuevaOrdenSalida from './views/proyectos/ordenes/NuevaOrdenSalida';
import EditarOrdenSalida from './views/proyectos/ordenes/EditarOrdenSalida';
import DetalleOrdenSalida from './views/proyectos/ordenes/DetalleOrdenSalida';
import NuevaOrdenDevolucion from './views/proyectos/devoluciones/NuevaOrdenDevolucion';
import EditarOrdenDevolucion from './views/proyectos/devoluciones/EditarOrdenDevolucion';
import DetalleOrdenDevolucion from './views/proyectos/devoluciones/DetalleOrdenDevolucion';

// Redux
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';



function App() {
	if (localStorage.token) {
		setAuthToken(localStorage.token);
	}

	useEffect(() => {
		store.dispatch(loadUser());
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout></Layout>
					<section className="container-fluid principal-section">
						<Alert></Alert>

						<Routes>
							{/* Login */}
							<Route exact path="/" element={<ValidateSession><Login /></ValidateSession>}/>
							<Route exact path="/login" element={<ValidateSession><Login /></ValidateSession>}/>

							{/* Dashboard */}
							<Route path="/dashboard" element={<PrivateRoute routePermission=''><Dashboard /></PrivateRoute>}/>

							{/* Usuarios */}
							<Route path="/usuarios" element={<PrivateRoute routePermission='usuarios.ver'><Usuarios /></PrivateRoute>}/>
							<Route path="/usuarios/nuevo" element={<PrivateRoute routePermission='usuarios.agregar'><NuevoUsuario /></PrivateRoute>}/>
							<Route path="/usuarios/editar/:id" element={<PrivateRoute routePermission='usuarios.editar'><EditarUsuario /></PrivateRoute>}/>

							{/* Proveedores */}
							<Route path="/proveedores" element={<PrivateRoute routePermission='proveedores.ver'><Proveedores /></PrivateRoute>}/>
							<Route path="/proveedores/nuevo" element={<PrivateRoute routePermission='proveedores.agregar'><NuevoProveedor /></PrivateRoute>}/>
							<Route path="/proveedores/editar/:id" element={<PrivateRoute routePermission='proveedores.editar'><EditarProveedor /></PrivateRoute>}/>
							<Route path="/proveedores/productos/:id" element={<PrivateRoute routePermission=''><ProductosProveedores /></PrivateRoute>}/>

							{/* Configuración */}
							<Route path="/configuracion/perfil" element={<PrivateRoute routePermission='configuracion.perfil.ver'><Perfil /></PrivateRoute>}/>
							<Route path="/configuracion/categorias" element={<PrivateRoute routePermission='configuracion.categorias.ver'><Categorias /></PrivateRoute>}/>
							<Route path="/configuracion/categorias/subcategorias/:id" element={<PrivateRoute routePermission='configuracion.categorias.subcategorias.ver'><Subcategorias /></PrivateRoute>}/>
							<Route path="/configuracion/productos" element={<PrivateRoute routePermission=''><Productos /></PrivateRoute>}/>
							<Route path="/configuracion/areas" element={<PrivateRoute routePermission=''><Areas /></PrivateRoute>}/>
							<Route path="/configuracion/areas/organizadores/:id" element={<PrivateRoute routePermission=''><Organizadores /></PrivateRoute>}/>
							<Route path="/configuracion/areas/organizadores/ubicaciones/:id" element={<PrivateRoute routePermission=''><Ubicaciones /></PrivateRoute>}/>
							<Route path="/configuracion/metodos" element={<PrivateRoute routePermission=''><MetodosPago /></PrivateRoute>}/>
							<Route path="/configuracion/unidades" element={<PrivateRoute routePermission=''><Unidades /></PrivateRoute>}/>
						<Route path="/configuracion/paquetes" element={<PrivateRoute routePermission=''><Paquetes /></PrivateRoute>}/>
						<Route path="/configuracion/paquetes/nuevo" element={<PrivateRoute routePermission=''><NuevoPaquete /></PrivateRoute>}/>
						<Route path="/configuracion/paquetes/editar/:id" element={<PrivateRoute routePermission=''><EditarPaquete /></PrivateRoute>}/>

							{/* Facturas */}
							<Route path="/facturas" element={<PrivateRoute routePermission=''><Facturas /></PrivateRoute>}/>
							<Route path="/facturas/nueva" element={<PrivateRoute routePermission=''><NuevaFactura /></PrivateRoute>}/>
							<Route path="/facturas/editar/:id" element={<PrivateRoute routePermission=''><EditarFactura /></PrivateRoute>}/>

							{/* Inventario */}
							<Route path="/inventario" element={<PrivateRoute routePermission=''><Inventario /></PrivateRoute>}/>
							<Route path="/inventario/movimientos/" element={<PrivateRoute routePermission=''><Movimientos /></PrivateRoute>}/>
							<Route path="/inventario/movimientos/nuevo" element={<PrivateRoute routePermission=''><NuevoMovimiento /></PrivateRoute>}/>
							<Route path="/inventario/carga" element={<PrivateRoute routePermission=''><CargaInventario /></PrivateRoute>}/>

							{/* Clientes */}
							<Route path="/clientes" element={<PrivateRoute routePermission=''><Clientes /></PrivateRoute>}/>
							<Route path="/clientes/detalle/:id" element={<PrivateRoute routePermission=''><DetalleCliente /></PrivateRoute>}/>

							{/* Ventas */}
							<Route path="/ventas" element={<PrivateRoute routePermission=''><Ventas /></PrivateRoute>}/>
							<Route path="/ventas/nueva" element={<PrivateRoute routePermission=''><NuevaVenta /></PrivateRoute>}/>
							<Route path="/ventas/editar/:id" element={<PrivateRoute routePermission=''><EditarVenta /></PrivateRoute>}/>
						<Route path="/ventas/detalle/:id" element={<PrivateRoute routePermission=''><DetalleVenta /></PrivateRoute>}/>

							{/* Proyectos */}
							<Route path="/proyectos" element={<PrivateRoute routePermission=''><Proyectos /></PrivateRoute>}/>
							<Route path="/proyectos/detalle/:id" element={<PrivateRoute routePermission=''><DetalleProyecto /></PrivateRoute>}/>
							<Route path="/proyectos/cotizaciones/nueva/:idProyecto" element={<PrivateRoute routePermission=''><NuevaCotizacion /></PrivateRoute>}/>
							<Route path="/proyectos/cotizaciones/editar/:id" element={<PrivateRoute routePermission=''><EditarCotizacion /></PrivateRoute>}/>
							<Route path="/proyectos/cotizaciones/detalle/:id" element={<PrivateRoute routePermission=''><DetalleCotizacion /></PrivateRoute>}/>
							<Route path="/proyectos/cotizaciones/version/:id" element={<PrivateRoute routePermission=''><NuevaVersionCotizacion /></PrivateRoute>}/>
							<Route path="/proyectos/ordenes/nueva/:idProyecto" element={<PrivateRoute routePermission=''><NuevaOrdenSalida /></PrivateRoute>}/>
							<Route path="/proyectos/ordenes/editar/:id" element={<PrivateRoute routePermission=''><EditarOrdenSalida /></PrivateRoute>}/>
							<Route path="/proyectos/ordenes/detalle/:id" element={<PrivateRoute routePermission=''><DetalleOrdenSalida /></PrivateRoute>}/>

							<Route path="/proyectos/devoluciones/nueva/:idProyecto" element={<PrivateRoute routePermission=''><NuevaOrdenDevolucion /></PrivateRoute>}/>
							<Route path="/proyectos/devoluciones/editar/:id" element={<PrivateRoute routePermission=''><EditarOrdenDevolucion /></PrivateRoute>}/>
							<Route path="/proyectos/devoluciones/detalle/:id" element={<PrivateRoute routePermission=''><DetalleOrdenDevolucion /></PrivateRoute>}/>

							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</section>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;